"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AiResponseEnvelope () {
        return AiResponseEnvelope;
    },
    get AskResponse () {
        return AskResponse;
    },
    get AskSource () {
        return AskSource;
    },
    get ChunkProcessingResponse () {
        return ChunkProcessingResponse;
    },
    get DefaultRephraseResponseStream () {
        return DefaultRephraseResponseStream;
    },
    get DocumentAgentResponse () {
        return DocumentAgentResponse;
    },
    get EngagementCohortInsightResponseStream () {
        return EngagementCohortInsightResponseStream;
    },
    get EngagementInsightResponseStream () {
        return EngagementInsightResponseStream;
    },
    get GeneralAgentResponse () {
        return GeneralAgentResponse;
    },
    get GetCompanyAISettingsResponse () {
        return GetCompanyAISettingsResponse;
    },
    get MeetingWorkspaceInsightResponseStream () {
        return MeetingWorkspaceInsightResponseStream;
    },
    get MetaDataAskResponse () {
        return MetaDataAskResponse;
    },
    get MetaDataChunkProcessingResponse () {
        return MetaDataChunkProcessingResponse;
    },
    get MetaDataDefaultRephraseResponseStream () {
        return MetaDataDefaultRephraseResponseStream;
    },
    get MetaDataEngagementCohortInsightResponseStream () {
        return MetaDataEngagementCohortInsightResponseStream;
    },
    get MetaDataEngagementInsightResponseStream () {
        return MetaDataEngagementInsightResponseStream;
    },
    get MetaDataMeetingWorkspaceInsightResponseStream () {
        return MetaDataMeetingWorkspaceInsightResponseStream;
    },
    get MetaDataReviewCycleInsightResponseStream () {
        return MetaDataReviewCycleInsightResponseStream;
    },
    get MetaDataReviewInsightResponseStream () {
        return MetaDataReviewInsightResponseStream;
    },
    get MetaDataSurveyInsightResponseStream () {
        return MetaDataSurveyInsightResponseStream;
    },
    get PatchCompanyAISettingsResponse () {
        return PatchCompanyAISettingsResponse;
    },
    get PostCompanyAISettingsResponse () {
        return PostCompanyAISettingsResponse;
    },
    get PostEmbeddingsResponse () {
        return PostEmbeddingsResponse;
    },
    get ReviewCycleInsightResponseStream () {
        return ReviewCycleInsightResponseStream;
    },
    get ReviewInsightResponseStream () {
        return ReviewInsightResponseStream;
    },
    get SurveyInsightResponseStream () {
        return SurveyInsightResponseStream;
    },
    get buildMeetingWorkspaceInsightSchema () {
        return buildMeetingWorkspaceInsightSchema;
    },
    get buildReviewCycleInsightSchema () {
        return buildReviewCycleInsightSchema;
    },
    get createSurveyInsightResponseStream () {
        return createSurveyInsightResponseStream;
    }
});
const _zod = require("zod");
const _models = require("@performyard/models");
const AiResponseEnvelope = _zod.z.object({
    promptHash: _zod.z.string(),
    isCached: _zod.z.boolean(),
    status: _zod.z.enum([
        "in_progress",
        "completed"
    ]),
    userId: _zod.z.string().optional(),
    createdBy: _zod.z.string().optional(),
    createdAt: _zod.z.date(),
    taskId: _zod.z.string().optional()
});
const PostEmbeddingsResponse = _zod.z.object({
    success: _zod.z.boolean()
});
const PostCompanyAISettingsResponse = _zod.z.object({
    success: _zod.z.boolean()
});
const PatchCompanyAISettingsResponse = _zod.z.object({
    success: _zod.z.boolean()
});
const GetCompanyAISettingsResponse = _models.AiSettingsSchema;
const ReviewInsightResponseStream = _zod.z.object({
    createdAt: _zod.z.string().default(new Date().toISOString()),
    completed: _zod.z.boolean().default(false),
    createdBy: _zod.z.string().default("Automated Insights"),
    subject: _zod.z.object({
        _id: _zod.z.string().describe("The ID of the subject"),
        name: _zod.z.string().describe("The name of the subject")
    }),
    title: _zod.z.string(),
    startDate: _zod.z.string().default(new Date().toISOString()),
    completedDate: _zod.z.string().default(new Date().toISOString()),
    insight: _zod.z.object({
        summary: _zod.z.string(),
        strengths: _zod.z.array(_zod.z.string()).optional(),
        opportunities: _zod.z.array(_zod.z.string()).optional(),
        actionItems: _zod.z.array(_zod.z.string()).optional(),
        disconnects: _zod.z.array(_zod.z.string()).optional(),
        generalAssessment: _zod.z.string().default(""),
        quotes: _zod.z.array(_zod.z.string()).optional(),
        tone: _zod.z.string().optional()
    })
});
const MetaDataReviewInsightResponseStream = _zod.z.object({
    data: ReviewInsightResponseStream
}).extend(AiResponseEnvelope.shape);
const DefaultRephraseResponseStream = _zod.z.object({
    answer: _zod.z.array(_zod.z.string()),
    detectedLanguage: _zod.z.string().optional(),
    genderedPronounsFound: _zod.z.array(_zod.z.string()),
    pronounRuleApplied: _zod.z.string()
});
const MetaDataDefaultRephraseResponseStream = _zod.z.object({
    data: DefaultRephraseResponseStream
}).extend(AiResponseEnvelope.shape);
// Base insight schema with all possible fields
const BaseSurveyInsightSchema = _zod.z.object({
    summary: _zod.z.string().describe("4-5 sentences minimum covering participation rate, key statistical findings, main themes from open-ended responses, demographic insights, and business impact."),
    sentiment: _zod.z.string().describe("string with numerical score (X/10) and detailed explanation including specific evidence from both rating data and open-ended responses, segmented by demographics where relevant.").optional(),
    keyThemesAndPatterns: _zod.z.array(_zod.z.string()).max(3).describe("The key themes and patterns of the survey.").optional(),
    outliers: _zod.z.array(_zod.z.string()).max(4).describe("The outliers of the survey.").optional(),
    crossQuestionInsights: _zod.z.array(_zod.z.string()).max(3).describe("The cross question insights of the survey.").optional(),
    recommendations: _zod.z.array(_zod.z.string()).max(3).describe("The recommendations of the survey.").optional(),
    demographicInsights: _zod.z.record(_zod.z.string(), _zod.z.string()).describe("The demographic insights of the survey.").optional()
});
const createSurveyInsightResponseStream = (settings)=>{
    const insightFields = {
        summary: BaseSurveyInsightSchema.shape.summary
    };
    // Only include fields that are enabled in settings
    if (settings.sentimentAnalysis) {
        insightFields.sentiment = BaseSurveyInsightSchema.shape.sentiment;
    }
    if (settings.keyThemesAndPatterns) {
        insightFields.keyThemesAndPatterns = BaseSurveyInsightSchema.shape.keyThemesAndPatterns;
    }
    if (settings.outliersAndNotableResponses) {
        insightFields.outliers = BaseSurveyInsightSchema.shape.outliers;
    }
    if (settings.actionableInsightsAndRecommendations) {
        insightFields.recommendations = BaseSurveyInsightSchema.shape.recommendations;
    }
    if (settings.demographicInsights) {
        insightFields.demographicInsights = BaseSurveyInsightSchema.shape.demographicInsights;
    }
    if (settings.crossQuestionInsights) {
        insightFields.crossQuestionInsights = BaseSurveyInsightSchema.shape.crossQuestionInsights;
    }
    return _zod.z.object({
        title: _zod.z.string().describe("The name of the survey"),
        startDate: _zod.z.string().nullable().describe("Start date of the analysis window in ISO 8601 format"),
        completedDate: _zod.z.string().nullable().describe("End date of the analysis window in ISO 8601 format"),
        totalResponses: _zod.z.number().describe("The total number of responses."),
        createdAt: _zod.z.string().default(new Date().toISOString()),
        createdBy: _zod.z.string().default("Automated Insights"),
        insight: _zod.z.object(insightFields)
    });
};
const SurveyInsightResponseStream = _zod.z.object({
    title: _zod.z.string().describe("The name of the survey"),
    startDate: _zod.z.string().nullable().describe("Start date of the analysis window in ISO 8601 format"),
    completedDate: _zod.z.string().nullable().describe("End date of the analysis window in ISO 8601 format"),
    totalResponses: _zod.z.number().describe("The total number of responses."),
    createdAt: _zod.z.string().default(new Date().toISOString()),
    createdBy: _zod.z.string().default("Automated Insights"),
    insight: BaseSurveyInsightSchema
});
const MetaDataSurveyInsightResponseStream = _zod.z.object({
    data: SurveyInsightResponseStream
}).extend(AiResponseEnvelope.shape);
const EngagementInsightResponseStream = _zod.z.object({
    question: _zod.z.string().describe("The question that was asked. Do not change the question from the original."),
    cohortName: _zod.z.string().describe("The cohort or team name the question was sent to."),
    startDate: _zod.z.string().nullable().describe("Start date of the analysis window in ISO 8601 format"),
    endDate: _zod.z.string().nullable().describe("End date of the analysis window in ISO 8601 format"),
    createdAt: _zod.z.string().default(new Date().toISOString()),
    createdBy: _zod.z.string().default("Automated Insights"),
    insight: _zod.z.object({
        summary: _zod.z.string().describe("Three-sentence summary of the key findings"),
        overallSentiment: _zod.z.string().describe("Overall sentiment with percentage breakdown ex: Negative (62% negative, 25% mixed, 13% positive) Do not include No Data Available"),
        positiveExamples: _zod.z.array(_zod.z.string()).max(3).describe("Examples of positive responses. Use array format for responses with lists, string format for regular responses. Use complete original text."),
        mixedExamples: _zod.z.array(_zod.z.string()).max(3).describe("Examples of mixed responses. Use array format for responses with lists, string format for regular responses. Use complete original text."),
        negativeExamples: _zod.z.array(_zod.z.string()).max(3).describe("Examples of negative responses. Use array format for responses with lists, string format for regular responses. Use complete original text."),
        themes: _zod.z.union([
            _zod.z.record(_zod.z.string(), _zod.z.string()),
            _zod.z.string()
        ]).describe("A set of key themes extracted from the responses. If there are no themes respond with `No Data Available`"),
        recommendations: _zod.z.array(_zod.z.string()).max(3).describe("Up to 3 actionable suggestions with a 2 sentence explanation. If there are no recommendations respond with `No Data Available`")
    })
});
const MetaDataEngagementInsightResponseStream = _zod.z.object({
    data: EngagementInsightResponseStream
}).extend(AiResponseEnvelope.shape);
const EngagementCohortInsightResponseStream = _zod.z.object({
    createdAt: _zod.z.string().default(new Date().toISOString()),
    completed: _zod.z.boolean().default(false),
    createdBy: _zod.z.string().default("Automated Insights"),
    userId: _zod.z.string(),
    insight: _zod.z.object({
        executiveSummary: _zod.z.string(),
        keyPerformanceAreas: _zod.z.record(_zod.z.string(), _zod.z.object({
            score: _zod.z.string().describe("Score analysis with format: X.X/5 for all employees or X.X for specific cohorts"),
            potentialReasons: _zod.z.array(_zod.z.string()).min(1).max(3).describe("1-3 bulleted reasons why this score may exist"),
            recommendations: _zod.z.array(_zod.z.string()).min(1).max(3).describe("1-3 bulleted recommendations on how to increase/maintain score"),
            explanation: _zod.z.string().describe("Summary explanation paragraph")
        })),
        ENPSImprovementStrategies: _zod.z.object({
            promoterStrategies: _zod.z.array(_zod.z.string()),
            detractorStrategies: _zod.z.array(_zod.z.string()),
            passiveStrategies: _zod.z.array(_zod.z.string())
        })
    })
});
const MetaDataEngagementCohortInsightResponseStream = _zod.z.object({
    data: EngagementCohortInsightResponseStream
}).extend(AiResponseEnvelope.shape);
const buildReviewCycleInsightSchema = (settings)=>{
    const insightFields = {
        summary: _zod.z.string()
    };
    // Only add fields for enabled sections
    if (settings.reviewToneDistribution) {
        insightFields.reviewToneDistribution = _zod.z.array(_zod.z.string()).or(_zod.z.string()).describe("Overall sentiment with percentage breakdown ex: [ Highly Positive: 43%, Moderately Positive: 29%, Neutral/Balanced: 14%, Moderately Negative: 14%, Highly Negative: 0% ]");
    }
    if (settings.highlightedReviews) {
        insightFields.highlightedReviews = _zod.z.object({
            topPerformers: _zod.z.array(_zod.z.string()).max(5).default([]),
            attentionRequired: _zod.z.array(_zod.z.string()).max(5).default([]),
            growthOpportunities: _zod.z.array(_zod.z.string()).max(5).default([])
        });
    }
    if (settings.keyStrengthsAndOpportunities) {
        insightFields.strengthsAnalysis = _zod.z.array(_zod.z.string()).default([]);
        insightFields.opportunitiesAnalysis = _zod.z.array(_zod.z.string()).default([]);
    }
    if (settings.commonThemesPositiveReviews) {
        insightFields.commonThemesForPositiveReviews = _zod.z.array(_zod.z.string()).default([]);
    }
    if (settings.commonThemesNegativeReviews) {
        insightFields.commonThemesForNegativeReviews = _zod.z.array(_zod.z.string()).default([]);
    }
    if (settings.recurringActionItems) {
        insightFields.recurringActionItems = _zod.z.array(_zod.z.string()).default([]);
    }
    if (settings.disconnectsAnalysis) {
        insightFields.disconnectsAnalysis = _zod.z.array(_zod.z.string()).default([]);
    }
    return _zod.z.object({
        createdAt: _zod.z.string().default(new Date().toISOString()),
        completed: _zod.z.boolean().default(false),
        createdBy: _zod.z.string().default("Automated Insights"),
        title: _zod.z.string(),
        startDate: _zod.z.string().default(new Date().toISOString()),
        completedDate: _zod.z.string().default(new Date().toISOString()),
        insight: _zod.z.object(insightFields).or(_zod.z.string())
    });
};
const ReviewCycleInsightResponseStream = _zod.z.object({
    createdAt: _zod.z.string().default(new Date().toISOString()),
    completed: _zod.z.boolean().default(false),
    createdBy: _zod.z.string().default("Automated Insights"),
    title: _zod.z.string(),
    startDate: _zod.z.string().default(new Date().toISOString()),
    completedDate: _zod.z.string().default(new Date().toISOString()),
    insight: _zod.z.object({
        summary: _zod.z.string(),
        reviewToneDistribution: _zod.z.array(_zod.z.string()).or(_zod.z.string()).describe("Overall sentiment with percentage breakdown ex: [ Highly Positive: 43%, Moderately Positive: 29%, Neutral/Balanced: 14%, Moderately Negative: 14%, Highly Negative: 0% ]").optional(),
        highlightedReviews: _zod.z.object({
            topPerformers: _zod.z.array(_zod.z.string()).max(5).default([]),
            attentionRequired: _zod.z.array(_zod.z.string()).max(5).default([]),
            growthOpportunities: _zod.z.array(_zod.z.string()).max(5).default([])
        }).optional(),
        strengthsAnalysis: _zod.z.array(_zod.z.string()).default([]).optional(),
        opportunitiesAnalysis: _zod.z.array(_zod.z.string()).default([]).optional(),
        commonThemesForPositiveReviews: _zod.z.array(_zod.z.string()).default([]).optional(),
        commonThemesForNegativeReviews: _zod.z.array(_zod.z.string()).default([]).optional(),
        recurringActionItems: _zod.z.array(_zod.z.string()).default([]).optional(),
        disconnectsAnalysis: _zod.z.array(_zod.z.string()).default([]).optional()
    }).or(_zod.z.string())
});
const MetaDataReviewCycleInsightResponseStream = _zod.z.object({
    data: ReviewCycleInsightResponseStream
}).extend(AiResponseEnvelope.shape);
const ChunkProcessingResponse = _zod.z.object({
    totalChunks: _zod.z.number(),
    completedChunks: _zod.z.number()
});
const MetaDataChunkProcessingResponse = _zod.z.object({
    data: ChunkProcessingResponse
}).extend(AiResponseEnvelope.shape);
const buildMeetingWorkspaceInsightSchema = (settings)=>{
    const insightFields = {
        executiveSummary: _zod.z.string()
    };
    // Only add fields for enabled sections
    if (settings.progressAndGrowth) {
        insightFields.progressAndGrowth = _zod.z.array(_zod.z.string());
    }
    if (settings.keyAccomplishmentsAndWins) {
        insightFields.keyAccomplishmentsAndWins = _zod.z.array(_zod.z.string());
    }
    if (settings.developmentAreasAndGrowthOpportunities) {
        insightFields.developmentAreasAndGrowthOpportunities = _zod.z.array(_zod.z.string());
    }
    if (settings.notableDiscussionsAndDecisions) {
        insightFields.notableDiscussionsAndDecisions = _zod.z.array(_zod.z.string());
    }
    if (settings.actionItemsAnalysis) {
        insightFields.actionItemAnalysis = _zod.z.string();
    }
    return _zod.z.object({
        createdAt: _zod.z.string().default(new Date().toISOString()),
        completed: _zod.z.boolean().default(false),
        createdBy: _zod.z.string().default("Automated Insights"),
        workspaceId: _zod.z.string(),
        workspaceName: _zod.z.string(),
        startDate: _zod.z.string(),
        endDate: _zod.z.string(),
        insight: _zod.z.object(insightFields)
    });
};
const MeetingWorkspaceInsightResponseStream = _zod.z.object({
    createdAt: _zod.z.string().default(new Date().toISOString()),
    completed: _zod.z.boolean().default(false),
    createdBy: _zod.z.string().default("Automated Insights"),
    workspaceId: _zod.z.string(),
    workspaceName: _zod.z.string(),
    startDate: _zod.z.string(),
    endDate: _zod.z.string(),
    insight: _zod.z.object({
        executiveSummary: _zod.z.string(),
        progressAndGrowth: _zod.z.array(_zod.z.string()).optional(),
        keyAccomplishmentsAndWins: _zod.z.array(_zod.z.string()).optional(),
        developmentAreasAndGrowthOpportunities: _zod.z.array(_zod.z.string()).optional(),
        notableDiscussionsAndDecisions: _zod.z.array(_zod.z.string()).optional(),
        actionItemAnalysis: _zod.z.string().optional()
    })
});
const MetaDataMeetingWorkspaceInsightResponseStream = _zod.z.object({
    data: MeetingWorkspaceInsightResponseStream
}).extend(AiResponseEnvelope.shape);
// Conversational AI Response - Scalable Agent Architecture
// Base response fields shared by all agents
const AskResponseBase = _zod.z.object({
    answer: _zod.z.string(),
    confidence: _zod.z.enum([
        "high",
        "medium",
        "low"
    ])
});
const AskSource = _zod.z.object({
    s3FileId: _zod.z.string(),
    filename: _zod.z.string(),
    chunkCount: _zod.z.number(),
    relevanceScore: _zod.z.number()
});
const UsageSchema = _zod.z.object({
    inputTokens: _zod.z.number(),
    outputTokens: _zod.z.number()
}).optional();
const DocumentAgentResponse = AskResponseBase.extend({
    agent: _zod.z.literal("document").default("document"),
    sources: _zod.z.array(AskSource),
    retrievalMetrics: _zod.z.object({
        totalChunksRetrieved: _zod.z.number(),
        chunksUsedInAnswer: _zod.z.number(),
        averageRelevanceScore: _zod.z.number(),
        scoreSource: _zod.z.enum([
            "vector",
            "rerank"
        ])
    }).optional(),
    usage: UsageSchema
});
const GeneralAgentResponse = AskResponseBase.extend({
    agent: _zod.z.literal("general"),
    usage: UsageSchema
});
const AskResponse = _zod.z.discriminatedUnion("agent", [
    DocumentAgentResponse,
    GeneralAgentResponse
]);
const MetaDataAskResponse = _zod.z.object({
    data: AskResponse
}).extend(AiResponseEnvelope.shape);
